import { Settings, Database, Shield } from 'lucide-react';

export default function SettingsPage() {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-lyrax-text">Configuración</h1>
        <p className="text-lyrax-text-secondary">Ajustes del panel de administración</p>
      </div>

      <div className="space-y-6">
        <div className="card">
          <div className="flex items-center gap-3 mb-4">
            <Shield className="w-5 h-5 text-lyrax-primary" />
            <h2 className="text-lg font-semibold text-lyrax-text">Super Admin</h2>
          </div>
          <p className="text-lyrax-text-secondary mb-4">
            Solo el usuario <strong>admin@lyrax.cl</strong> tiene acceso a este panel.
          </p>
          <div className="p-3 bg-lyrax-surface-hover rounded-lg">
            <p className="text-sm text-lyrax-text-secondary">Cuenta actual</p>
            <p className="font-medium text-lyrax-text">admin@lyrax.cl</p>
          </div>
        </div>

        <div className="card">
          <div className="flex items-center gap-3 mb-4">
            <Database className="w-5 h-5 text-lyrax-primary" />
            <h2 className="text-lg font-semibold text-lyrax-text">Base de Datos</h2>
          </div>
          <p className="text-lyrax-text-secondary mb-4">
            Los tenants se almacenan en schemas separados de PostgreSQL.
          </p>
          <div className="p-3 bg-lyrax-surface-hover rounded-lg font-mono text-sm">
            <p className="text-lyrax-text-secondary">public_config.tenants</p>
            <p className="text-lyrax-text-secondary">tenant_{'{slug}'}.*</p>
          </div>
        </div>

        <div className="card">
          <div className="flex items-center gap-3 mb-4">
            <Settings className="w-5 h-5 text-lyrax-primary" />
            <h2 className="text-lg font-semibold text-lyrax-text">API</h2>
          </div>
          <p className="text-lyrax-text-secondary">
            Endpoints disponibles en <code className="bg-lyrax-surface-hover px-1 rounded text-lyrax-text">/api/super-admin/*</code>
          </p>
        </div>
      </div>
    </div>
  );
}
